import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=6b46452c&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=ts&"
export * from "./Details.vue?vue&type=script&lang=ts&"
import style0 from "./Details.vue?vue&type=style&index=0&id=6b46452c&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b46452c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Guidance: require('C:/inetpub/wwwroot/bike-flights/components/guidance/Guidance.vue').default,Modal: require('C:/inetpub/wwwroot/bike-flights/components/Modal.vue').default})
